import type { ReactNode } from 'react';

// ============================================================
// DeviceFrame — molduras SVG/CSS de smartphone e desktop
// ============================================================

export function PhoneFrame({ children, alt }: { children?: ReactNode; alt: string }) {
  return (
    <figure className="lume-device" role="img" aria-label={alt}>
      <span aria-hidden="true" className="lume-device__bezel" />
      <div className="lume-device__screen">
        {children ?? <DeviceSkeleton />}
      </div>
    </figure>
  );
}

export function DesktopFrame({ children, alt }: { children?: ReactNode; alt: string }) {
  return (
    <figure className="lume-device lume-device--desktop" role="img" aria-label={alt}>
      <div className="lume-device__screen">
        {children ?? <DeviceSkeleton />}
      </div>
    </figure>
  );
}

function DeviceSkeleton() {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        background:
          'linear-gradient(135deg, var(--color-bg-muted) 0%, var(--color-bg-subtle) 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--color-fg-subtle)',
        fontFamily: 'var(--font-display)',
        fontSize: '0.85rem',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
      }}
    >
      Captura em breve
    </div>
  );
}
